import React, { useState, useEffect } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import Select from "react-select";
import { useTranslation } from 'react-i18next';
// api
import { getCategories, getGallery } from "api/company";
// components
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import Tile from "./tile";

const Gallery = () => {
  const { t } = useTranslation(['backoffice', 'libraries']);
  const [allImages, setAllImages] = useState([]);
  const [images, setImages] = useState([]);
  const [options, setOptions] = useState([]);
  const [category, setCategory] = useState("");

  const title = t('gallery');

  useEffect(() => {
    async function handelCategories() {
      const rs = await getCategories();
      if (rs.status === 200) {
        let o = [];
        o.push({ value: "", label: t('allCategories') });
        rs.data.map((item) => o.push({ value: item, label: item }));
        setOptions(o);
      }
    }
    async function handleGallery() {
      const rs = await getGallery();
      if (rs.status === 200) {
        setImages(rs.data);
        setAllImages(rs.data);
        const galleryImgs = rs.data.map(function (x) {
          return x.image;
        });
        galleryImgs.forEach((element) => preloadImages(element));
      }
    }
    function preloadImages(url) {
      let img = new Image();
      img.src = url;
    }
    handelCategories();
    handleGallery();
  }, []);

  useEffect(() => {
    if (category === "") {
      setImages(allImages);
    } else {
      const data = allImages.filter((item) => item.category === category.label);
      setImages(data);
    }
  }, [category, allImages]);

  const goUp = () => {
    window.scrollTo(0, 0);
  };
  goUp();

  const clearsearch = () => {
    setCategory('');
  };

  return (
    <Container className="justify-content-center d-flex mainDiv gallery">
      <Head title={title} noIndex={true} />
      <Row className='container-row justify-content-center'>
        <Col lg={3} md={9} sm={10} className="filter-col">
          <TitleWithLine text={title} />
          <div>
            <Col md={11} className="mb-3">
              <Select
                options={options}
                value={category}
                onChange={(e) => setCategory(e)}
                placeholder={t('filterByCategory')}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: "#e5e5e5",
                    primary: "#969595",
                  },
                })}
              />
            </Col>
            <Col md={11}>
              <Button onClick={clearsearch} className="w-100 btn-clear">
                {t('clearsearch', { ns: 'libraries' })}
              </Button>
            </Col>
          </div>
        </Col>
        <Col lg={9} className="mt-4 h-100">
          <div className="container margin-bottom-md">
            <Row className="content-tiles">
              <Col>
                <div className="tiles">
                  {images.map((d, i) => {
                    return <Tile key={i} data={d} index={i} images={images} />;
                  })}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Gallery;
